import type { SearchUrlParams } from '@/types/search/SearchUrlParams';

import { fetchDataForAuctionCalendarPage } from '@/redux/modules/auctionCalendar/auctionCalendar.actions';
import { getSearchPageSize } from '@/redux/modules/pagination';
import { DataLoaderParams } from '@/types/DataLoaderParams';
import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { parseQueryParams } from '@/utils/queryParams';

type AuctionCalendarQueryParams = Pick<SearchUrlParams, 'pageSize'> & {
    //Experiment: SEAR-1266 Average Lot Value Auction Calendar Ranking
    auctionCalendarRankingVersion?: string;
};

const AUCTION_CALENDAR_RANKING_VERSION = 'alv_ranking';

export default ({ amplitudeExperimentFlags, location, store }: DataLoaderParams) => {
    const { dispatch, getState } = store;
    const state = getState();
    const pageSize = getSearchPageSize(state);

    const queryParams: AuctionCalendarQueryParams = parseQueryParams(location.search);
    queryParams.pageSize = pageSize; // ignore pageSize in the url

    //Experiment: SEAR-1266 Average Lot Value Auction Calendar Ranking
    const hasAverageLotValueActionCalendarRankingTreatment =
        amplitudeExperimentFlags[AmplitudeExperiments.AverageLotValueActionCalendarRanking]?.value ===
        AmplitudeVariants.AverageLotValueActionCalendarRanking.Treatment;

    if (hasAverageLotValueActionCalendarRankingTreatment) {
        queryParams.auctionCalendarRankingVersion = AUCTION_CALENDAR_RANKING_VERSION;
    }

    return dispatch(fetchDataForAuctionCalendarPage(queryParams));
};
